
export const formatError = (error: any): string => {
  if (typeof error === 'string') return error;
  if (error?.message) return error.message;
  if (error?.error) return error.error;
  if (typeof error === 'object') {
    return JSON.stringify(error, null, 2);
  }
  return 'Unknown error occurred';
};

export const cleanBarcodeData = (data: any, scannerType?: string): string | null => {
  if (!data) return null;
  
  let cleanData = String(data).trim();
  console.log(`🧹 Cleaning barcode data from ${scannerType || 'unknown'} scanner:`, cleanData);
  
  // Remove obvious corruption patterns
  if (cleanData.includes('\n')) {
    cleanData = cleanData.replace(/\n/g, '');
  }
  if (cleanData.includes('\r')) {
    cleanData = cleanData.replace(/\r/g, '');
  }
  
  // Enhanced leading zero removal logic - more aggressive for Scandit
  if (cleanData.startsWith('0') && cleanData.length > 1) {
    const withoutPrefix = cleanData.substring(1);
    
    // Standard barcode lengths: 8 (EAN-8), 12 (UPC-A), 13 (EAN-13), 14 (GTIN-14)
    const standardLengths = [8, 12, 13, 14];
    
    // For Scandit scanner, be more aggressive in removing leading zeros
    if (scannerType === 'Scandit') {
      // Remove leading zero if:
      // 1. The resulting length would be a standard length
      // 2. OR the current length is suspiciously long (>14 digits)
      // 3. AND it's all digits
      if ((/^\d+$/.test(withoutPrefix)) && 
          (standardLengths.includes(withoutPrefix.length) || cleanData.length > 14)) {
        console.log('🎯 Scandit: Removing spurious leading "0" from barcode:', cleanData, '->', withoutPrefix);
        cleanData = withoutPrefix;
      } else {
        console.log('🔍 Scandit: Preserving legitimate barcode with leading zero:', cleanData);
      }
    } else {
      // Original logic for other scanners
      if (!standardLengths.includes(cleanData.length) && 
          standardLengths.includes(withoutPrefix.length) && 
          /^\d+$/.test(withoutPrefix)) {
        console.log('🎯 Removing corrupted "0" prefix from barcode:', cleanData, '->', withoutPrefix);
        cleanData = withoutPrefix;
      } else {
        console.log('🔍 Preserving legitimate barcode with leading zero:', cleanData);
      }
    }
  }
  
  console.log(`✅ Final cleaned barcode data:`, cleanData);
  return cleanData;
};
